import { area, length } from "@turf/turf";

const HECTARE_FACTOR = 0.0001;

export function displayStartEndVertexes(feature: GeoJSON.GeoJSON, display: (geojson: GeoJSON.GeoJSON) => void) {
    if (
        feature.type !== "Feature" ||
        feature.geometry.type !== "LineString" ||
        feature.geometry.coordinates.length < 2 ||
        feature.properties?.id === undefined
    )
        return;

    const firstPoint = feature.geometry.coordinates[0];
    display({
        type: "Feature",
        properties: {
            meta: "firstPoint",
            parent: feature.properties.id,
        },
        geometry: {
            type: "Point",
            coordinates: firstPoint,
        },
    });

    const lastPoint = feature.geometry.coordinates[feature.geometry.coordinates.length - 1];
    display({
        type: "Feature",
        properties: {
            meta: "lastPoint",
            parent: feature.properties.id,
        },
        geometry: {
            type: "Point",
            coordinates: lastPoint,
        },
    });
}

function getDisplayMeasurements(geojson: GeoJSON.Feature) {
    switch (geojson.geometry.type) {
        case "LineString": {
            const len = length(geojson);
            return `${len.toFixed(2)}km`;
        }
        case "Polygon":
        case "MultiPolygon":
            return `${(area(geojson) * HECTARE_FACTOR).toFixed(2)}HA`;
        default:
            return geojson.type;
    }
}

export function createMeasurementVertex(
    geojson: GeoJSON.Feature,
    parentId: string | number,
    coordinate: GeoJSON.Position,
): GeoJSON.Feature {
    const displayMeasurements = getDisplayMeasurements(geojson);

    // create custom feature for the current pointer position
    return {
        type: "Feature",
        properties: {
            meta: "currentPosition",
            measurement: displayMeasurements,
            parent: parentId,
        },
        geometry: {
            type: "Point",
            coordinates: coordinate,
        },
    };
}
